"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseQueryWithReauth = void 0;
var query_1 = require("@reduxjs/toolkit/query");
var auth_1 = require("firebase/auth");
var auth_2 = require("../features/slices/auth");
var firebase_1 = require("./firebase");
var baseQueryWithReauth = function (customBaseUrl) {
    return function (args, store, extraOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var baseQuery, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    baseQuery = (0, query_1.fetchBaseQuery)({
                        baseUrl: customBaseUrl,
                        prepareHeaders: function (headers_1, _a) { return __awaiter(void 0, [headers_1, _a], void 0, function (headers, _b) {
                            var auth, useFirebaseToken, currentUser, userCredential, firebaseToken, e_1;
                            var getState = _b.getState;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        auth = getState().auth;
                                        useFirebaseToken = headers.get("x-use-firebase-token") === "true";
                                        if (!useFirebaseToken) return [3 /*break*/, 7];
                                        headers.delete("x-use-firebase-token");
                                        _c.label = 1;
                                    case 1:
                                        _c.trys.push([1, 5, , 6]);
                                        currentUser = firebase_1.auth.currentUser;
                                        if (!!currentUser) return [3 /*break*/, 3];
                                        return [4 /*yield*/, (0, auth_1.signInAnonymously)(firebase_1.auth)];
                                    case 2:
                                        userCredential = _c.sent();
                                        currentUser = userCredential.user;
                                        _c.label = 3;
                                    case 3: return [4 /*yield*/, currentUser.getIdToken()];
                                    case 4:
                                        firebaseToken = _c.sent();
                                        headers.set("Authorization", "Bearer ".concat(firebaseToken));
                                        return [3 /*break*/, 6];
                                    case 5:
                                        e_1 = _c.sent();
                                        console.warn("Unable to get Firebase ID token for request:", e_1);
                                        return [3 /*break*/, 6];
                                    case 6: return [3 /*break*/, 8];
                                    case 7:
                                        if (auth.access_token) {
                                            headers.set("Authorization", "Bearer ".concat(auth.access_token));
                                        }
                                        _c.label = 8;
                                    case 8: return [2 /*return*/, headers];
                                }
                            });
                        }); },
                    });
                    return [4 /*yield*/, baseQuery(args, store, extraOptions)];
                case 1:
                    result = _a.sent();
                    if (result.error && result.error.status === 401) {
                        // Since we don't have refresh tokens in this implementation,
                        // we'll just clear the auth state (redux-persist will handle persistence)
                        // Clear Redux state (redux-persist will automatically clear persisted state)
                        store.dispatch((0, auth_2.clearCredentials)());
                        // Optionally redirect to login page or show login modal
                        // window.location.href = '/login';
                    }
                    return [2 /*return*/, result];
            }
        });
    }); };
};
exports.baseQueryWithReauth = baseQueryWithReauth;
